/** Staff → installer profile: send one of the custom email templates to this installer. */
import React, { useEffect, useState } from 'react';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import API_URL from '@/config/api';
import { Button } from '@/components/ui/button';
import { formatApiError } from '@/utils/apiError';

export function SendTemplateEmailModal({ open, onClose, installer }) {
  const [templates, setTemplates] = useState(null);
  const [tid, setTid] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    fetch(`${API_URL}/api/staff/email-templates`, { credentials: 'include' }).then((r) => r.json()).then((d) => { setTemplates(d.templates || []); setTid(d.templates?.[0]?.id || ''); }).catch(() => setTemplates([]));
  }, [open]);
  if (!open) return null;
  const tpl = templates?.find((t) => t.id === tid);
  const send = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/staff/email-templates/${tid}/send`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ installer_ids: [installer.user_id] }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(formatApiError(d) || 'Send failed');
      toast.success(`Email sent to ${installer.name}`); onClose();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="profile-email-modal">
      <div className="bg-white rounded-2xl w-full max-w-lg shadow-xl p-5 space-y-3">
        <div className="flex items-center gap-2"><h2 className="font-bold text-gray-900 flex-1">Email {installer.name}</h2><Button variant="ghost" size="sm" onClick={onClose} data-testid="profile-email-close">Close</Button></div>
        <div className="text-xs text-gray-500">To: {installer.email || 'no email on file'}</div>
        {!templates ? <div className="py-6 text-center"><Loader2 className="w-5 h-5 animate-spin inline text-gray-400" /></div>
          : !templates.length ? <p className="text-sm text-gray-500">No email templates yet — create one in Message Centre → Email templates.</p> : (
            <>
              <select value={tid} onChange={(e) => setTid(e.target.value)} className="w-full h-10 border rounded-md px-3 text-sm bg-white" data-testid="profile-email-template">{templates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</select>
              {tpl && <div className="text-sm text-gray-700 bg-gray-50 border rounded px-3 py-2"><span className="font-semibold">Subject:</span> {tpl.subject}</div>}
              <Button onClick={send} disabled={busy || !installer.email || !tid} className="w-full h-11 bg-[#7A0B7A] hover:bg-[#5e085e] text-white font-bold" data-testid="profile-email-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-2" /> Send email</>}</Button>
            </>
          )}
      </div>
    </div>
  );
}
